export const richTextConfig = {
    licenseKey: ""
};
